import { makeStyles, Text } from '@rneui/themed'
import { font } from 'app/theme'
import { Image } from 'expo-image'
import { SummaryItem } from 'home/types'
import React from 'react'
import { Linking, Pressable, View } from 'react-native'
import { TileItemDescription } from './description'
import { Title } from './title'

const url = 'https://dailypay.app.link/NEXTDailyPay'

export type Props = {
  item: SummaryItem
  color?: string
  error?: Error
}

export function DailyPayItem({ item, color, error }: Props) {
  const styles = useStyles(color)

  return (
    <Pressable style={styles.container}>
      {item.badge ? (
        <View style={{ paddingLeft: 16, paddingTop: 10 }}>
          <View style={styles.badgeContainer}>
            <Text style={styles.badgeText}>{item.badge}</Text>
          </View>
        </View>
      ) : null}
      <Title title={item.title} color={color} showCaret={false} />

      {item.description ? (
        <TileItemDescription
          description={item.description}
          error={error}
          numberOfLines={2}
          textStyle={[styles.description, { marginTop: 0 }]}
        />
      ) : null}

      <View style={styles.callToAction}>
        <Pressable
          onPress={() => {
            Linking.openURL(url).catch(err =>
              console.warn('Error opening DailyPay link:', err)
            )
          }}
        >
          <Image
            contentFit="contain"
            source={require('assets/dailypay/dailypay-signup.png')}
            style={styles.dailypayicon}
          />
        </Pressable>
      </View>
    </Pressable>
  )
}

const useStyles = makeStyles((theme, color: string | undefined) => ({
  container: {
    flex: 1,
  },
  description: {
    fontSize: 13,
    marginHorizontal: 16,
    marginVertical: 10,
    opacity: 0.8,
    color: color,
  },
  callToAction: {
    alignItems: 'flex-start',
    paddingTop: 4,
    paddingHorizontal: 12,
  },
  dailypayicon: {
    width: 142,
    height: 30,
  },
  badgeContainer: {
    borderWidth: 1,
    borderColor: 'red',
    borderRadius: 4,
    alignSelf: 'flex-start',
  },
  badgeText: {
    color: 'red',
    paddingHorizontal: 4,
    paddingVertical: 1,
    fontSize: 12,
    fontFamily: font.bold,
  },
}))
